import Text, { TextProps } from 'UIKit/Text'

const pad = (num: number): string => {
  return num < 10 ? `0${num}` : `${num}`
}

const formatAbsoluteDate = (date: Date): string => {
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}`
}

const formatNaturalAgoEn = (date: Date): string => {
  const now = new Date()
  let diffMs = now.getTime() - date.getTime()
  if (diffMs < 0) diffMs = 0

  const msPerDay = 24 * 60 * 60 * 1000

  // Calculate months difference
  let months = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth())

  // If the current day is less than the date's day, subtract one month
  if (now.getDate() < date.getDate()) {
    months -= 1
  }

  // Calculate the date after subtracting full months
  const monthAdjustedDate = new Date(date)
  monthAdjustedDate.setMonth(monthAdjustedDate.getMonth() + months)

  // Calculate remaining days after months
  const daysAfterMonths = Math.floor((now.getTime() - monthAdjustedDate.getTime()) / msPerDay)

  // If more than 2 weeks, show absolute date
  const diffDays = Math.floor(diffMs / msPerDay)
  if (diffDays > 14) {
    return formatAbsoluteDate(date)
  }

  // If months >= 1, show months and days
  if (months >= 1) {
    if (daysAfterMonths > 0) {
      return `${months}mo ${daysAfterMonths}d ago`
    }
    return `${months}mo ago`
  }

  // If less than a month, calculate weeks and days
  const weeks = Math.floor(diffDays / 7)
  const days = diffDays % 7

  if (weeks >= 1) {
    if (days > 0) {
      return `${weeks}w ${days}d ago`
    }
    return `${weeks}w ago`
  }

  // Only days
  if (diffDays > 0) {
    return `${diffDays}d ago`
  }

  // Less than a day: show hours and minutes
  const diffHours = Math.floor(diffMs / (60 * 60 * 1000))
  const diffMinutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000))
  if (diffHours > 0) {
    if (diffMinutes > 0) {
      return `${diffHours}h ${diffMinutes}m ago`
    }
    return `${diffHours}h ago`
  }
  if (diffMinutes > 0) {
    return `${diffMinutes}m ago`
  }
  return 'just now'
}

export const TimeSinceDetails: React.FC<{ date: Date } & TextProps> = ({ date, ...props }) => {
  return <Text {...props}>{formatNaturalAgoEn(date)}</Text>
}

// FORMAT

// Just now	:        just now
// 5 minutes ago	: 5m ago
// 2 hours ago	: 2h ago
// 1 day ago	: 1d ago
// 6 days ago	: 6d ago
// 13 days ago	: 1w 6d ago
// 15 days ago	: 1w 1d ago
// 1 month ago	: 23/05/2025 17:13

// if time > 2 weeks show absolute date
